import { ThemeInterface } from '../helpers/styled';
import { colors } from './colors';

export const theme: ThemeInterface = {
  pallette: colors,
};
